package kz.dentalcrm.app.theme

import androidx.compose.runtime.Composable
import androidx.compose.runtime.Immutable
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.platform.LocalWindowInfo
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontFamily
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.unit.times
import dentalcrm.composeapp.generated.resources.Res
import dentalcrm.composeapp.generated.resources.inter_black
import dentalcrm.composeapp.generated.resources.inter_bold
import dentalcrm.composeapp.generated.resources.inter_extra_bold
import dentalcrm.composeapp.generated.resources.inter_extra_light
import dentalcrm.composeapp.generated.resources.inter_light
import dentalcrm.composeapp.generated.resources.inter_medium
import dentalcrm.composeapp.generated.resources.inter_regular
import dentalcrm.composeapp.generated.resources.inter_semi_bold
import dentalcrm.composeapp.generated.resources.inter_thin
import kz.dentalcrm.app.core.ui.window.WindowSize
import org.jetbrains.compose.resources.Font

@Composable
fun DefaultFonts() = FontFamily(
    Font(resource = Res.font.inter_thin, weight = FontWeight.W100),
    Font(resource = Res.font.inter_extra_light, weight = FontWeight.W200),
    Font(resource = Res.font.inter_light, weight = FontWeight.W300),
    Font(resource = Res.font.inter_regular, weight = FontWeight.W400),
    Font(resource = Res.font.inter_medium, weight = FontWeight.W500),
    Font(resource = Res.font.inter_semi_bold, weight = FontWeight.W600),
    Font(resource = Res.font.inter_bold, weight = FontWeight.W700),
    Font(resource = Res.font.inter_extra_bold, weight = FontWeight.W800),
    Font(resource = Res.font.inter_black, weight = FontWeight.W900)
)

@Immutable
data class ThemeTypography(
    val display: TextStyle = TextStyle(),
    val heading1: TextStyle = TextStyle(),
    val heading2: TextStyle = TextStyle(),
    val heading3: TextStyle = TextStyle(),
    val subHeading1: TextStyle = TextStyle(),
    val subHeading2: TextStyle = TextStyle(),
    val bodyLargeRegular: TextStyle = TextStyle(),
    val bodyLargeMedium: TextStyle = TextStyle(),
    val bodyMediumRegular: TextStyle = TextStyle(),
    val bodyMediumMedium: TextStyle = TextStyle(),
    val bodySmallRegular: TextStyle = TextStyle(),
    val bodySmallMedium: TextStyle = TextStyle(),
    val captionRegular: TextStyle = TextStyle(),
    val captionMedium: TextStyle = TextStyle(),
    val labelRegular: TextStyle = TextStyle(),
    val labelMedium: TextStyle = TextStyle()
)

@OptIn(ExperimentalComposeUiApi::class)
@Composable
fun Typography() = ThemeTypography().run {
    val interFonts = DefaultFonts()
    copy(
        display = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 40.sp,
            lineHeight = 44.sp,
        ),
        heading1 = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 32.sp,
            lineHeight = 36.sp,
        ),
        heading2 = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 28.sp,
            lineHeight = 32.sp,
        ),
        heading3 = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 24.sp,
            lineHeight = 28.sp,
        ),
        subHeading1 = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 20.sp,
            lineHeight = 28.sp,
        ),
        subHeading2 = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W600,
            fontSize = 18.sp,
            lineHeight = 24.sp,
        ),
        bodyLargeRegular = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W400,
            fontSize = 18.sp,
            lineHeight = 24.sp,
        ),
        bodyLargeMedium = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W500,
            fontSize = 18.sp,
            lineHeight = 24.sp,
        ),
        bodyMediumRegular = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W400,
            fontSize = 16.sp,
            lineHeight = 24.sp,
        ),
        bodyMediumMedium = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W500,
            fontSize = 16.sp,
            lineHeight = 24.sp,
        ),
        bodySmallRegular = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W400,
            fontSize = 14.sp,
            lineHeight = 20.sp,
        ),
        bodySmallMedium = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W500,
            fontSize = 14.sp,
            lineHeight = 20.sp,
        ),
        captionRegular = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W400,
            fontSize = 12.sp,
            lineHeight = 16.sp,
        ),
        captionMedium = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W500,
            fontSize = 12.sp,
            lineHeight = 16.sp,
        ),
        labelRegular = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W400,
            fontSize = 12.sp,
            lineHeight = 16.sp,
        ),
        labelMedium = TextStyle(
            fontFamily = interFonts,
            fontWeight = FontWeight.W500,
            fontSize = 12.sp,
            lineHeight = 16.sp,
        )
    )
}